import { AdminIntro, AdminNav, AdminMetrics, AdminSearch, normalizeSearch } from "../../components/AdminWorkspace";
import React, { useState, useCallback, useContext, useEffect } from "react";
import clsx from "clsx";
import { toast } from "react-toastify";
import { add, format, parseISO } from "date-fns";

import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
// import { SocketContext } from "../../context/Socket/SocketContext";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  ButtonBase,
  TableBody,
  TableRow,
  TableCell,
  IconButton,
  Table,
  TableHead,
  Tooltip,
  Typography,
  CircularProgress,
  Box,
  Dialog,
  DialogContent,
  DialogActions,
  Divider,
  TextField,
  MenuItem as MuiMenuItem,
  Switch,
} from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import {
  Add,
  ArrowForward,
  ChevronRight,
  Edit,
  ExpandMore,
  DeleteOutline,
  Facebook,
  HeadsetMic,
  Instagram,
  MoreVert,
  Refresh,
  SettingsInputAntenna,
  SwapHoriz,
  Sync,
  ViewModule,
  ViewList,
  WhatsApp,
} from "@material-ui/icons";
import WebhookIcon from '@mui/icons-material/Webhook';
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";

import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import MainHeaderButtonsWrapper from "../../components/MainHeaderButtonsWrapper";
import Title from "../../components/Title";
import TableRowSkeleton from "../../components/TableRowSkeleton";
import EmptyState from "../../components/EmptyState";
import { StatusBadge } from "../../components/ui";
import { ChannelTile, ConnectionStatus, CHANNEL_COLOR, channelIcon, channelLabel, connectionNumber } from "../../components/ConnectionIcon/ConnectionStatus";
import { usePanelStyles, ModalTitle, TableCard, RowActions } from "../../components/FormFields/panel";
import { getTokens, brandAlpha } from "../../styles/tokens";

import api from "../../services/api";
import WhatsAppModal from "../../components/WhatsAppModal";
import ConfirmationModal from "../../components/ConfirmationModal";
import QrcodeModal from "../../components/QrcodeModal";
import { i18n } from "../../translate/i18n";
import { WhatsAppsContext } from "../../context/WhatsApp/WhatsAppsContext";
import toastError from "../../errors/toastError";
import { AuthContext } from "../../context/Auth/AuthContext";
import usePlans from "../../hooks/usePlans";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ForbiddenPage from "../../components/ForbiddenPage";
import { Can } from "../../components/Can";
import { filterOutboundConnections } from "../../utils/channels";

const useStyles = makeStyles((theme) => {
  const t = getTokens(theme.palette.type, theme.palette.primary.main);
  const danger = t.mode === "dark" ? t.status.down.fg : t.semantic.error;
  return {
    /* ---------- Barra de filtros ---------- */
    filterSelect: { minWidth: 190, [theme.breakpoints.down("xs")]: { flex: "1 1 160px" } },
    viewToggle: {
      marginLeft: "auto",
      display: "flex",
      gap: 2,
      padding: 2,
      backgroundColor: t.paper,
      border: `1px solid ${t.line}`,
      borderRadius: t.radius.sm,
      "& .MuiIconButton-root": { width: 34, height: 34, padding: 0, borderRadius: t.radius.badge, color: t.textSecondary },
      "& .MuiSvgIcon-root": { fontSize: 20 },
    },
    viewActive: { backgroundColor: `${t.tint.soft} !important`, color: `${t.brand} !important` },

    /* ---------- Menus ---------- */
    // o tema limita o menu a 300 px; os rótulos de canal precisam de um pouco mais
    wideMenu: { maxWidth: "min(360px, calc(100vw - 24px)) !important" },
    menuItem: { gap: 10, whiteSpace: "normal", "& .MuiSvgIcon-root": { flex: "none", fontSize: 20 } },
    menuIcon: { color: t.textSecondary },
    menuHint: { marginLeft: "auto", paddingLeft: 8, fontSize: 11.5, color: t.textMuted, whiteSpace: "nowrap" },
    menuDanger: { color: danger, "& .MuiSvgIcon-root": { color: danger } },
    menuDivider: { margin: "6px 4px" },

    /* ---------- Importação de mensagens ---------- */
    importCard: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 16,
      marginBottom: 14,
      padding: "14px 16px",
      backgroundColor: t.paper,
      border: `1px solid ${t.line}`,
      borderRadius: t.radius.md,
      boxShadow: t.shadow.card,
    },
    importTitle: { margin: 0, fontSize: 14, fontWeight: 600, lineHeight: 1.4, color: t.text },
    importText: { margin: "2px 0 0", fontSize: 13, lineHeight: 1.5, color: t.textSecondary },

    /* ---------- Sessão ---------- */
    badgeButton: { borderRadius: t.radius.badge, "&:focus-visible": { outline: `2px solid ${t.brand}`, outlineOffset: 2 } },
    sessionActions: { display: "flex", alignItems: "center", flexWrap: "wrap", gap: 6 },
    // rótulos de botão vêm em minúsculas do i18n ("desconectar")
    cap: { display: "inline-block", "&::first-letter": { textTransform: "uppercase" } },
    spinner: { color: t.textMuted },

    /* ---------- Cartões ---------- */
    cards: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fill, minmax(290px, 1fr))",
      gap: 14,
      alignItems: "stretch",
      [theme.breakpoints.down("xs")]: { gridTemplateColumns: "minmax(0, 1fr)" },
    },
    card: {
      display: "flex",
      flexDirection: "column",
      minWidth: 0,
      overflow: "hidden",
      backgroundColor: t.paper,
      border: `1px solid ${t.line}`,
      borderRadius: t.radius.md,
      boxShadow: t.shadow.card,
    },
    cardHead: { display: "flex", alignItems: "flex-start", gap: 12, padding: "16px 16px 12px" },
    cardTitle: { minWidth: 0, flex: 1 },
    cardName: {
      margin: 0,
      fontFamily: t.font,
      fontSize: 15,
      fontWeight: 600,
      lineHeight: 1.35,
      color: t.text,
      overflowWrap: "anywhere",
    },
    cardChannel: { margin: "1px 0 0", fontSize: 12.5, lineHeight: 1.45, color: t.textSecondary },
    cardMeta: { display: "grid", gap: 8, padding: "0 16px 14px" },
    metaLine: { display: "flex", alignItems: "center", flexWrap: "wrap", gap: 6 },
    cardNumber: { fontSize: 14, fontWeight: 500, lineHeight: 1.4, color: t.text, fontVariantNumeric: "tabular-nums" },
    cardNumberEmpty: { fontWeight: 400, color: t.textMuted },
    cardUpdated: { fontSize: 12, lineHeight: 1.4, color: t.textMuted },
    links: { borderTop: `1px solid ${t.line}` },
    linkRow: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 12,
      padding: "10px 12px 10px 16px",
      fontFamily: t.font,
      fontSize: 13,
      lineHeight: 1.4,
      textAlign: "left",
      color: t.text,
      borderBottom: `1px solid ${t.lineRow}`,
      transition: `background-color ${t.motion.fast}`,
      "&:last-child": { borderBottom: "none" },
      "&:hover": { backgroundColor: t.muted },
      "&:focus-visible": { outline: `2px solid ${t.brand}`, outlineOffset: -2 },
    },
    linkLabel: { flex: "none", fontWeight: 500 },
    linkValue: {
      display: "flex",
      alignItems: "center",
      gap: 2,
      minWidth: 0,
      color: t.textSecondary,
      "& .MuiSvgIcon-root": { flex: "none", fontSize: 18, color: t.textMuted },
    },
    linkText: { overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" },
    cardFoot: {
      marginTop: "auto",
      display: "flex",
      alignItems: "center",
      flexWrap: "wrap",
      gap: 8,
      padding: "12px 12px 12px 16px",
      borderTop: `1px solid ${t.line}`,
      backgroundColor: t.muted,
      "&:empty": { display: "none" },
    },
    cardFootEnd: { marginLeft: "auto", display: "flex", alignItems: "center", gap: 4 },
    moreButton: { width: 32, height: 32, padding: 0, color: t.textSecondary, "& .MuiSvgIcon-root": { fontSize: 20 } },

    /* ---------- Lista ---------- */
    nameCell: { display: "flex", alignItems: "center", gap: 12, minWidth: 180 },
    nameText: { minWidth: 0 },
    nameLine: { display: "flex", alignItems: "center", flexWrap: "wrap", gap: 8, fontWeight: 600, color: t.text },
    nameSub: { fontSize: 12.5, lineHeight: 1.4, color: t.textSecondary },
    nowrap: { whiteSpace: "nowrap" },

    /* ---------- Diálogos de transferência ---------- */
    lead: { margin: "0 0 18px", fontSize: 14, lineHeight: 1.6, color: t.mode === "dark" ? t.text : t.label },
    transferGrid: {
      display: "grid",
      gridTemplateColumns: "minmax(0, 1fr) auto minmax(0, 1fr)",
      alignItems: "end",
      gap: 12,
      "& .MuiFormControl-root": { margin: 0 },
      [theme.breakpoints.down("xs")]: { gridTemplateColumns: "minmax(0, 1fr)" },
    },
    transferArrow: {
      height: 40,
      display: "grid",
      placeItems: "center",
      color: t.textMuted,
      [theme.breakpoints.down("xs")]: { display: "none" },
    },
    progress: { display: "flex", flexDirection: "column", alignItems: "center", gap: 6, padding: "12px 0 8px", textAlign: "center" },
    progressValue: { fontSize: 15, fontWeight: 600, color: t.text, fontVariantNumeric: "tabular-nums" },
    progressTrack: { color: brandAlpha(t.brand, 0.16) },
    progressCount: { marginTop: 10, fontSize: 14, fontWeight: 600, color: t.text },
    progressHint: { fontSize: 13, color: t.textSecondary },
  };
});

function CircularProgressWithLabel(props) {
  return (
    <Box position="relative" display="inline-flex">
      <CircularProgress variant="determinate" {...props} />
      <Box
        top={0}
        left={0}
        bottom={0}
        right={0}
        position="absolute"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Typography
          variant="caption"
          component="div"
          color="textSecondary"
        >{`${Math.round(props.value)}%`}</Typography>
      </Box>
    </Box>
  );
}

const FB_APP_CONFIGURED = Boolean(process.env.REACT_APP_FACEBOOK_APP_ID);

const MENU_RIGHT = {
  getContentAnchorEl: null,
  anchorOrigin: { vertical: "bottom", horizontal: "right" },
  transformOrigin: { vertical: "top", horizontal: "right" },
};

const Connections = () => {
  const classes = useStyles();
  const p = usePanelStyles();

  const { whatsApps, loading } = useContext(WhatsAppsContext);
  const [channelSection, setChannelSection] = useState("general");
  const [whatsAppModalOpen, setWhatsAppModalOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [connectionFilter, setConnectionFilter] = useState("all");
  const [view, setView] = useState("cards");
  const [statusImport, setStatusImport] = useState([]);
  const [qrModalOpen, setQrModalOpen] = useState(false);
  const [selectedWhatsApp, setSelectedWhatsApp] = useState(null);
  const [channel, setChannel] = useState("whatsapp");
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const history = useHistory();
  const confirmationModalInitialState = {
    action: "",
    title: "",
    message: "",
    whatsAppId: "",
    open: false,
  };
  const [confirmModalInfo, setConfirmModalInfo] = useState(confirmationModalInitialState);
  const [planConfig, setPlanConfig] = useState(false);
  // Embedded Signup da Meta: botão "Conectar pela Meta" quando a plataforma tem o app configurado
  const [metaSignup, setMetaSignup] = useState({ enabled: false, platformUrl: "" });
  const [transferModalOpen, setTransferModalOpen] = useState(false);
  const [sourceConnection, setSourceConnection] = useState("");
  const [targetConnection, setTargetConnection] = useState("");
  const [preDeleteModalOpen, setPreDeleteModalOpen] = useState(false);
  const [whatsAppToDelete, setWhatsAppToDelete] = useState(null);
  const [transferProgressModalOpen, setTransferProgressModalOpen] = useState(false);
  const [transferProgress, setTransferProgress] = useState({ current: 0, total: 0, percentage: 0 });

  //   const socketManager = useContext(SocketContext);
  const { user, socket } = useContext(AuthContext);

  const companyId = user.companyId;

  const { getPlanCompany } = usePlans();

  useEffect(() => {
    async function fetchData() {
      const planConfigs = await getPlanCompany(undefined, companyId);
      setPlanConfig(planConfigs)
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    api.get("/meta-signup/config").then(({ data }) => setMetaSignup(data)).catch(() => {});
  }, []);

  const responseFacebook = (response) => {
    if (response.status !== "unknown") {
      const { accessToken, id } = response;

      api
        .post("/facebook", {
          facebookUserId: id,
          facebookUserToken: accessToken,
        })
        .then((response) => {
          toast.success(i18n.t("connections.facebook.success"));
        })
        .catch((error) => {
          toastError(error);
        });
    }
  };

  const responseInstagram = (response) => {
    if (response.status !== "unknown") {
      const { accessToken, id } = response;

      api
        .post("/facebook", {
          addInstagram: true,
          facebookUserId: id,
          facebookUserToken: accessToken,
        })
        .then((response) => {
          toast.success(i18n.t("connections.facebook.success"));
        })
        .catch((error) => {
          toastError(error);
        });
    }
  };

  useEffect(() => {
    // const socket = socketManager.GetSocket();

    socket.on(`importMessages-${user.companyId}`, (data) => {
      if (data.action === "refresh") {
        setStatusImport([]);
        history.go(0);
      }
      if (data.action === "update") {
        setStatusImport(data.status);
      }
    });

    socket.on(`transferTickets-${user.companyId}`, (data) => {
      if (data.action === "progress") {
        setTransferProgress({
          current: data.current,
          total: data.total,
          percentage: Math.round((data.current / data.total) * 100)
        });
      }
      if (data.action === "completed") {
        setTransferProgressModalOpen(false);
        setTransferProgress({ current: 0, total: 0, percentage: 0 });
        toast.success(`Transferência concluída! ${data.transferred} tickets transferidos com sucesso.`);
        handleCloseTransferModal();
      }
      if (data.action === "error") {
        setTransferProgressModalOpen(false);
        setTransferProgress({ current: 0, total: 0, percentage: 0 });
        toast.error("Erro na transferência de tickets.");
      }
    });

    /* return () => {
      socket.disconnect();
    }; */
  }, [whatsApps]);

  const handleStartWhatsAppSession = async (whatsAppId) => {
    try {
      await api.post(`/whatsappsession/${whatsAppId}`);
    } catch (err) {
      toastError(err);
    }
  };

  const handleRequestNewQrCode = async (whatsAppId) => {
    try {
      await api.put(`/whatsappsession/${whatsAppId}`);
    } catch (err) {
      toastError(err);
    }
  };

  // Abre o popup do Embedded Signup SEMPRE no host da plataforma (único domínio autorizado no app
  // Meta) e entrega token + origem por postMessage; o popup devolve o id da conexão criada.
  // coex=true → coexistência: o número continua no app WhatsApp Business do celular.
  const openMetaSignup = (coex = false) => {
    const url = `${(metaSignup.platformUrl || window.location.origin).replace(/\/$/, "")}/meta/signup${coex ? "?coex=1" : ""}`;
    const popup = window.open(url, "digiteai-meta-signup", "width=760,height=820,menubar=no,toolbar=no");
    if (!popup) {
      toast.error(i18n.t("connections.metaSignup.popupBlocked"));
      return;
    }
    const popupOrigin = new URL(url).origin;
    let token = null;
    try { token = JSON.parse(localStorage.getItem("token")); } catch (e) { token = null; }
    let acked = false;
    let finished = false;
    const cleanup = () => { finished = true; window.removeEventListener("message", onMsg); clearInterval(tick); };
    const tick = setInterval(() => {
      if (finished) return;
      // popup fechado sem resposta terminal: solta o listener (senão a próxima tentativa dispara em dobro);
      // 1 s de folga para não perder um "done" postado logo antes do window.close()
      if (popup.closed) { setTimeout(() => { if (!finished) cleanup(); }, 1000); clearInterval(tick); return; }
      if (!acked) popup.postMessage({ type: "digiteai:meta-signup:init", token, companyId: user.companyId, origin: window.location.origin }, popupOrigin);
    }, 500);
    const onMsg = async (event) => {
      if (event.origin !== popupOrigin || typeof event.data?.type !== "string" || !event.data.type.startsWith("digiteai:meta-signup:")) return;
      if (event.data.type === "digiteai:meta-signup:ack") { acked = true; return; }
      cleanup();
      if (event.data.type === "digiteai:meta-signup:done") {
        toast.success(i18n.t(event.data.status === "pin_required" ? "connections.metaSignup.pinRequired" : "connections.metaSignup.done"));
        try {
          const { data } = await api.get(`/whatsapp/${event.data.whatsappId}`);
          handleEditWhatsApp(data, "credentials");
        } catch (err) {
          toastError(err);
        }
      }
    };
    window.addEventListener("message", onMsg);
  };

  const handleOpenWhatsAppModal = (channel = "whatsapp") => {
    setChannelSection("general");
    setChannel(channel)
    setSelectedWhatsApp(null);
    setWhatsAppModalOpen(true);
  };

  const handleCloseWhatsAppModal = useCallback(() => {
    setWhatsAppModalOpen(false);
    setSelectedWhatsApp(null);
  }, [setSelectedWhatsApp, setWhatsAppModalOpen]);

  const handleOpenQrModal = (whatsApp) => {
    setSelectedWhatsApp(whatsApp);
    setQrModalOpen(true);
  };

  const handleCloseQrModal = useCallback(() => {
    setSelectedWhatsApp(null);
    setQrModalOpen(false);
  }, [setQrModalOpen, setSelectedWhatsApp]);

  const handleEditWhatsApp = (whatsApp, section = "general") => {
    setChannelSection(section);
    setChannel(whatsApp.channel)
    setSelectedWhatsApp(whatsApp);
    setWhatsAppModalOpen(true);
  };

  const handleSyncTemplates = async (whatsAppId) => {
    await api.get(`/whatsapp/sync-templates/${whatsAppId}`);
  }

  const handleCopyWebhook = async (url) => {
    if (!url) { toast.info("O webhook ainda não está disponível para este canal."); return; }
    try { await navigator.clipboard.writeText(url); toast.success("Webhook copiado"); } catch (err) { toast.error("Não foi possível copiar o webhook."); }
  };

  const openInNewTab = url => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const handleOpenConfirmationModal = (action, whatsAppId) => {
    if (action === "disconnect") {
      setConfirmModalInfo({
        action: action,
        title: i18n.t("connections.confirmationModal.disconnectTitle"),
        message: i18n.t("connections.confirmationModal.disconnectMessage"),
        whatsAppId: whatsAppId,
      });
    }

    if (action === "delete") {
      setConfirmModalInfo({
        action: action,
        title: i18n.t("connections.confirmationModal.deleteTitle"),
        message: i18n.t("connections.confirmationModal.deleteMessage"),
        whatsAppId: whatsAppId,
      });
    }
    if (action === "closedImported") {
      setConfirmModalInfo({
        action: action,
        title: i18n.t("connections.confirmationModal.closedImportedTitle"),
        message: i18n.t("connections.confirmationModal.closedImportedMessage"),
        whatsAppId: whatsAppId,
      });
    }

    setConfirmModalOpen(true);
  };

  const handleSubmitConfirmationModal = async () => {
    if (confirmModalInfo.action === "disconnect") {
      try {
        await api.delete(`/whatsappsession/${confirmModalInfo.whatsAppId}`);
      } catch (err) {
        toastError(err);
      }
    }

    if (confirmModalInfo.action === "delete") {
      try {
        await api.delete(`/whatsapp/${confirmModalInfo.whatsAppId}`);
        toast.success(i18n.t("connections.toasts.deleted"));
      } catch (err) {
        toastError(err);
      }
    }
    if (confirmModalInfo.action === "closedImported") {
      try {
        await api.post(`/closedimported/${confirmModalInfo.whatsAppId}`);
        toast.success(i18n.t("connections.toasts.closedimported"));
      } catch (err) {
        toastError(err);
      }
    }


    setConfirmModalInfo(confirmationModalInitialState);
  };


  const renderImportButton = (whatsApp) => {
    if (whatsApp?.statusImportMessages === "renderButtonCloseTickets") {
      return (
        <Button
          size="small"
          variant="outlined"
          color="primary"
          onClick={() => {
            handleOpenConfirmationModal("closedImported", whatsApp.id);
          }}
        >
          {i18n.t("connections.buttons.closedImported")}
        </Button>
      );
    }

    if (whatsApp?.importOldMessages) {
      let isTimeStamp = !isNaN(
        new Date(Math.floor(whatsApp?.statusImportMessages)).getTime()
      );

      if (isTimeStamp) {
        const ultimoStatus = new Date(
          Math.floor(whatsApp?.statusImportMessages)
        ).getTime();
        const dataLimite = +add(ultimoStatus, { seconds: +35 }).getTime();
        if (dataLimite > new Date().getTime()) {
          return (
            <>
              <Button
                disabled
                size="small"
                endIcon={
                  <CircularProgress
                    size={12}
                    className={classes.spinner}
                  />
                }
                variant="outlined"
                color="primary"
              >
                {i18n.t("connections.buttons.preparing")}
              </Button>
            </>
          );
        }
      }
    }
  };

  const renderActionButtons = (whatsApp) => {
    if (whatsApp.channel === "webchat") {
      return (
        <>
          <Switch
            size="small" color="primary"
            checked={whatsApp.status === "CONNECTED"}
            onChange={async (_, active) => {
              try {
                await api.put(`/webchat-admin/connections/${whatsApp.id}/active`, { active });
              } catch (err) {
                toastError(err);
              }
            }}
            inputProps={{ "aria-label": i18n.t(whatsApp.status === "CONNECTED" ? "connections.webchat.active" : "connections.webchat.inactive") }}
          />
          <Button
            size="small" variant="outlined"
            onClick={async () => {
              try {
                const { data } = await api.get(`/webchat-admin/connections/${whatsApp.id}`);
                await navigator.clipboard.writeText(data.url);
                toast.success(i18n.t("connections.webchat.linkCopied"));
              } catch (err) {
                toastError(err);
              }
            }}
          >
            {i18n.t("connections.webchat.copyLink")}
          </Button>
        </>
      );
    }
    return (
      <>
        {whatsApp.channel === "whatsapp" && whatsApp.status === "qrcode" && (
          <Can
            role={user.profile === "user" && user.allowConnections === "enabled" ? "admin" : user.profile}
            perform="connections-page:addConnection"
            yes={() => (
              <Button
                size="small"
                variant="contained"
                color="primary"
                onClick={() => handleOpenQrModal(whatsApp)}
              >
                <span className={classes.cap}>{i18n.t("connections.buttons.qrcode")}</span>
              </Button>
            )}
          />
        )}
        {whatsApp.channel === "whatsapp" && whatsApp.status === "DISCONNECTED" && (
          <Can
            role={user.profile === "user" && user.allowConnections === "enabled" ? "admin" : user.profile}
            perform="connections-page:addConnection"
            yes={() => (
              <>
                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  onClick={() => handleStartWhatsAppSession(whatsApp.id)}
                >
                  <span className={classes.cap}>{i18n.t("connections.buttons.tryAgain")}</span>
                </Button>
                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => handleRequestNewQrCode(whatsApp.id)}
                >
                  <span className={classes.cap}>{i18n.t("connections.buttons.newQr")}</span>
                </Button>
              </>
            )}
          />
        )}
        {(whatsApp.channel === "whatsapp" && (whatsApp.status === "CONNECTED" ||
          whatsApp.status === "PAIRING" ||
          whatsApp.status === "TIMEOUT")) && (
            <Can
              role={user.profile}
              perform="connections-page:addConnection"
              yes={() => (
                <>
                  <Button
                    size="small"
                    variant="outlined"
                    onClick={() => {
                      handleOpenConfirmationModal("disconnect", whatsApp.id);
                    }}
                  >
                    <span className={classes.cap}>{i18n.t("connections.buttons.disconnect")}</span>
                  </Button>

                  {renderImportButton(whatsApp)}
                </>
              )}
            />
          )}
        {(whatsApp.channel === "whatsapp" && whatsApp.status === "OPENING") && (
          <Button size="small" variant="outlined" disabled color="default">
            {i18n.t("connections.buttons.connecting")}
          </Button>
        )}
      </>
    );
  };

  // Pendência do cadastro pela Meta (PIN, registro, análise): leva à aba de credenciais.
  // Coexistência: o número segue no app WhatsApp Business; o selo mostra o andamento da sincronização.
  const renderMetaSignupBadge = (wa) => (
    <>
      {wa.channel === "whatsapp_oficial" && wa.metaSignupStatus && wa.metaSignupStatus !== "ok" ? (
        <Tooltip title={i18n.t(`metaSignup.status.${wa.metaSignupStatus}`)}>
          <ButtonBase className={classes.badgeButton} onClick={() => handleEditWhatsApp(wa, "credentials")}>
            <StatusBadge color="warning" label={i18n.t(`connections.metaSignup.chip.${wa.metaSignupStatus}`)} />
          </ButtonBase>
        </Tooltip>
      ) : null}
      {wa.channel === "whatsapp_oficial" && wa.metaCoexistence ? (
        <Tooltip title={i18n.t(`metaSignup.coexSync.${wa.metaSyncStatus || "none"}`, { count: wa.metaSyncMessages || 0 })}>
          <ButtonBase className={classes.badgeButton} onClick={() => handleEditWhatsApp(wa, "credentials")}>
            <StatusBadge color="info" label={i18n.t("connections.metaSignup.chip.coexistence")} />
          </ButtonBase>
        </Tooltip>
      ) : null}
    </>
  );

  // Ações menos usadas da conexão: modelos e webhook (API oficial) e a exclusão.
  const renderMoreMenu = (wa) => (
    <PopupState variant="popover" popupId={`connection-menu-${wa.id}`}>
      {(menuState) => (
        <>
          <Tooltip title="Mais ações">
            <IconButton
              size="small"
              className={classes.moreButton}
              aria-label={`Mais ações de ${wa.name}`}
              {...bindTrigger(menuState)}
            >
              <MoreVert />
            </IconButton>
          </Tooltip>
          <Menu {...bindMenu(menuState)} {...MENU_RIGHT}>
            {wa.channel === "whatsapp_oficial" && (
              <MenuItem
                className={classes.menuItem}
                onClick={() => {
                  menuState.close();
                  handleSyncTemplates(wa.id);
                }}
              >
                <Sync className={classes.menuIcon} />
                Sincronizar templates
              </MenuItem>
            )}
            {wa.channel === "whatsapp_oficial" && (
              <MenuItem
                className={classes.menuItem}
                onClick={() => {
                  menuState.close();
                  handleCopyWebhook(wa.waba_webhook);
                }}
              >
                <WebhookIcon className={classes.menuIcon} />
                Copiar webhook para Meta
              </MenuItem>
            )}
            {wa.channel === "whatsapp_oficial" && <Divider component="li" className={classes.menuDivider} />}
            <MenuItem
              className={clsx(classes.menuItem, classes.menuDanger)}
              onClick={() => {
                menuState.close();
                handleOpenPreDeleteModal(wa.id);
              }}
            >
              <DeleteOutline />
              Excluir conexão
            </MenuItem>
          </Menu>
        </>
      )}
    </PopupState>
  );

  const renderUpdatedAt = (wa) => (wa.updatedAt ? format(parseISO(wa.updatedAt), "dd/MM/yy HH:mm") : "—");

  const renderCard = (wa) => {
    const number = connectionNumber(wa);
    return (
      <article className={classes.card} key={wa.id}>
        <div className={classes.cardHead}>
          <ChannelTile channel={wa.channel} color={wa.color} />
          <div className={classes.cardTitle}>
            <h2 className={classes.cardName}>{wa.name}</h2>
            <p className={classes.cardChannel}>{channelLabel(wa.channel)}</p>
          </div>
          {wa.isDefault && <StatusBadge color="brand" dot={false} size="sm" label={i18n.t("connections.table.default")} />}
        </div>
        <div className={classes.cardMeta}>
          <div className={classes.metaLine}>
            <ConnectionStatus status={wa.status} />
            <Can role={user.profile} perform="connections-page:addConnection" yes={() => renderMetaSignupBadge(wa)} />
          </div>
          <div className={clsx(classes.cardNumber, !number && classes.cardNumberEmpty)}>{number || "Número não informado"}</div>
          <div className={classes.cardUpdated}>Atualizado em {renderUpdatedAt(wa)}</div>
        </div>
        <Can role={user.profile} perform="connections-page:addConnection" yes={() => (
          <div className={classes.links}>
            <ButtonBase className={classes.linkRow} onClick={() => handleEditWhatsApp(wa, "integrations")}>
              <span className={classes.linkLabel}>Filas de atendimento</span>
              <span className={classes.linkValue}>
                <span className={classes.linkText}>{wa.queues?.length ? wa.queues.map(q => q.name).join(", ") : "Configurar"}</span>
                <ChevronRight />
              </span>
            </ButtonBase>
            {user.showFlow === "enabled" && planConfig?.plan?.useIntegrations && wa.channel !== "webchat" && (
              <ButtonBase className={classes.linkRow} onClick={() => handleEditWhatsApp(wa, "flowbuilder")}>
                <span className={classes.linkLabel}>Fluxos de conversa</span>
                <span className={classes.linkValue}><span className={classes.linkText}>Configurar</span><ChevronRight /></span>
              </ButtonBase>
            )}
            {wa.channel === "whatsapp_oficial" && (
              <ButtonBase className={classes.linkRow} onClick={() => handleEditWhatsApp(wa, "credentials")}>
                <span className={classes.linkLabel}>API oficial Meta</span>
                <span className={classes.linkValue}><span className={classes.linkText}>Configurar</span><ChevronRight /></span>
              </ButtonBase>
            )}
          </div>
        )} />
        <div className={classes.cardFoot}>
          {renderActionButtons(wa)}
          <Can role={user.profile} perform="connections-page:addConnection" yes={() => (
            <div className={classes.cardFootEnd}>
              <Button size="small" variant="outlined" startIcon={<Edit />} onClick={() => handleEditWhatsApp(wa)}>Configurar</Button>
              {renderMoreMenu(wa)}
            </div>
          )} />
        </div>
      </article>
    );
  };

  const renderEmpty = () => (
    <EmptyState
      icon={<SettingsInputAntenna />}
      title={whatsApps.length ? "Nenhum canal corresponde aos filtros" : "Nenhum canal cadastrado"}
      message={whatsApps.length ? "Ajuste a busca ou o filtro de status." : "Use “Nova conexão” para ligar o primeiro canal de atendimento."}
    />
  );

  const restartWhatsapps = async () => {

    try {
      await api.post(`/whatsapp-restart/`);
      toast.success(i18n.t("connections.waitConnection"));
    } catch (err) {
      toastError(err);
    }
  }

  const handleOpenTransferModal = () => {
    setTransferModalOpen(true);
  };

  const handleCloseTransferModal = () => {
    setTransferModalOpen(false);
    setSourceConnection("");
    setTargetConnection("");
  };

  const handleCloseTransferProgressModal = () => {
    setTransferProgressModalOpen(false);
    setTransferProgress({ current: 0, total: 0, percentage: 0 });
  };

  const handleTransferTickets = async () => {
    if (!sourceConnection || !targetConnection) {
      toast.error("Selecione as conexões de origem e destino");
      return;
    }

    if (sourceConnection === targetConnection) {
      toast.error("As conexões de origem e destino devem ser diferentes");
      return;
    }

    try {
      const response = await api.post(`/transfer-tickets`, {
        sourceConnectionId: sourceConnection,
        targetConnectionId: targetConnection
      });

      if (response.data.requiresProgress) {
        setTransferModalOpen(false);
        setTransferProgressModalOpen(true);
        setTransferProgress({ current: 0, total: response.data.totalTickets, percentage: 0 });
      } else {
        toast.success(`Tickets transferidos com sucesso! ${response.data.transferred || 0} tickets transferidos.`);
        handleCloseTransferModal();
      }
    } catch (err) {
      toastError(err);
    }
  };

  const handleOpenPreDeleteModal = (whatsAppId) => {
    setWhatsAppToDelete(whatsAppId);
    setPreDeleteModalOpen(true);
  };

  const handleClosePreDeleteModal = () => {
    setPreDeleteModalOpen(false);
    setWhatsAppToDelete(null);
  };

  const handleConfirmTransferDone = () => {
    setPreDeleteModalOpen(false);
    handleOpenConfirmationModal("delete", whatsAppToDelete);
    setWhatsAppToDelete(null);
  };

  const visibleConnections = whatsApps.filter(wa => normalizeSearch(`${wa.name} ${wa.number || ""} ${wa.phone_number || ""}`).includes(normalizeSearch(search)) && (connectionFilter === "all" || ((wa.status === "CONNECTED") === (connectionFilter === "connected") && !(connectionFilter === "attention" && wa.channel === "webchat"))));

  return (
    <MainContainer maxWidth scroll>
      <ConfirmationModal
        title={confirmModalInfo.title}
        open={confirmModalOpen}
        onClose={setConfirmModalOpen}
        onConfirm={handleSubmitConfirmationModal}
      >
        {confirmModalInfo.message}
      </ConfirmationModal>
      {qrModalOpen && (
        <QrcodeModal
          open={qrModalOpen}
          onClose={handleCloseQrModal}
          whatsAppId={!whatsAppModalOpen && selectedWhatsApp?.id}
        />
      )}
      <WhatsAppModal
        initialSection={channelSection}
        open={whatsAppModalOpen}
        onClose={handleCloseWhatsAppModal}
        whatsAppId={!qrModalOpen && selectedWhatsApp?.id}
        channel={channel}
      />
      <Dialog
        open={transferModalOpen}
        onClose={handleCloseTransferModal}
        maxWidth="sm"
        fullWidth
        scroll="paper"
        classes={{ paper: p.dialogPaper }}
      >
        <ModalTitle
          title="Transferir tickets"
          subtitle="Move os atendimentos ativos de uma conexão para outra."
          onClose={handleCloseTransferModal}
        />
        <DialogContent className={clsx(p.modalBody, p.labelsAbove)}>
          <p className={classes.lead}>
            Selecione a conexão de <strong>origem</strong> (de onde os tickets serão movidos)
            e a conexão de <strong>destino</strong> (para onde os tickets serão transferidos).
            Todos os atendimentos ativos da conexão de origem serão movidos para a conexão de destino.
          </p>

          <div className={classes.transferGrid}>
            <TextField
              select
              fullWidth
              variant="outlined"
              size="small"
              label="Origem"
              value={sourceConnection}
              onChange={(e) => setSourceConnection(e.target.value)}
            >
              {filterOutboundConnections(whatsApps).map((whatsApp) => (
                <MuiMenuItem key={whatsApp.id} value={whatsApp.id}>
                  {whatsApp.name}
                </MuiMenuItem>
              ))}
            </TextField>

            <div className={classes.transferArrow} aria-hidden="true">
              <ArrowForward fontSize="small" />
            </div>

            <TextField
              select
              fullWidth
              variant="outlined"
              size="small"
              label="Destino"
              value={targetConnection}
              onChange={(e) => setTargetConnection(e.target.value)}
            >
              {filterOutboundConnections(whatsApps).map((whatsApp) => (
                <MuiMenuItem key={whatsApp.id} value={whatsApp.id}>
                  {whatsApp.name}
                </MuiMenuItem>
              ))}
            </TextField>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseTransferModal}>
            Cancelar
          </Button>
          <Button onClick={handleTransferTickets} color="primary" variant="contained">
            Transferir
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={transferProgressModalOpen}
        onClose={handleCloseTransferProgressModal}
        maxWidth="xs"
        fullWidth
        disableBackdropClick
        disableEscapeKeyDown
        classes={{ paper: p.dialogPaper }}
      >
        <ModalTitle title="Transferindo tickets" subtitle="Progresso da transferência" />
        <DialogContent className={p.modalBody}>
          <div className={classes.progress}>
            <Box position="relative" display="inline-flex">
              <CircularProgress
                variant="determinate"
                value={100}
                size={80}
                thickness={4}
                className={classes.progressTrack}
              />
              <Box top={0} left={0} position="absolute" display="inline-flex">
                <CircularProgress
                  variant="determinate"
                  value={transferProgress.percentage}
                  size={80}
                  thickness={4}
                />
              </Box>
              <Box
                top={0}
                left={0}
                bottom={0}
                right={0}
                position="absolute"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <span className={classes.progressValue}>{transferProgress.percentage}%</span>
              </Box>
            </Box>

            <div className={classes.progressCount}>
              {transferProgress.current} de {transferProgress.total} tickets transferidos
            </div>

            <div className={classes.progressHint}>
              Por favor, aguarde enquanto os tickets são transferidos...
            </div>
          </div>
        </DialogContent>
      </Dialog>
      <Dialog
        open={preDeleteModalOpen}
        onClose={handleClosePreDeleteModal}
        maxWidth="xs"
        fullWidth
        classes={{ paper: p.dialogPaper }}
      >
        <ModalTitle title="Transferência de tickets" onClose={handleClosePreDeleteModal} />
        <DialogContent className={p.modalBody}>
          <p className={classes.lead} style={{ marginBottom: 0 }}>
            Antes de excluir esta conexão, você já fez a transferência dos tickets para outra conexão?
          </p>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClosePreDeleteModal}>
            Não
          </Button>
          <Button onClick={handleConfirmTransferDone} color="primary" variant="contained">
            Sim
          </Button>
        </DialogActions>
      </Dialog>
      {user.profile === "user" && user.allowConnections === "disabled" ?
        <ForbiddenPage />
        :
        <>
          <AdminIntro title="Canais de atendimento" description="Acompanhe suas conexões e configure como cada canal participa da operação." actions={<>
              {/* Ações de manutenção, menos usadas que "Nova conexão" */}
              <PopupState variant="popover" popupId="connections-more-menu">
                {(moreState) => (
                  <>
                    <Button variant="outlined" endIcon={<ExpandMore />} {...bindTrigger(moreState)}>
                      Mais ações
                    </Button>
                    <Menu {...bindMenu(moreState)} {...MENU_RIGHT} classes={{ paper: classes.wideMenu }}>
                      <MenuItem
                        className={classes.menuItem}
                        onClick={() => {
                          moreState.close();
                          handleOpenTransferModal();
                        }}
                      >
                        <SwapHoriz className={classes.menuIcon} />
                        {i18n.t("metaBusinessAssets.transferTickets")}
                      </MenuItem>
                      <MenuItem
                        className={classes.menuItem}
                        onClick={() => {
                          moreState.close();
                          restartWhatsapps();
                        }}
                      >
                        <Refresh className={classes.menuIcon} />
                        {i18n.t("connections.restartConnections")}
                      </MenuItem>
                      <MenuItem
                        className={classes.menuItem}
                        onClick={() => {
                          moreState.close();
                          openInNewTab(`https://wa.me/${process.env.REACT_APP_NUMBER_SUPPORT}`);
                        }}
                      >
                        <HeadsetMic className={classes.menuIcon} />
                        {i18n.t("connections.callSupport")}
                      </MenuItem>
                    </Menu>
                  </>
                )}
              </PopupState>
              <PopupState variant="popover" popupId="demo-popup-menu">
                {(popupState) => (
                  <React.Fragment>
                    <Can
                      role={user.profile}
                      perform="connections-page:addConnection"
                      yes={() => (
                        <>
                          <Button
                            variant="contained"
                            color="primary"
                            startIcon={<Add />}
                            {...bindTrigger(popupState)}
                          >
                            {i18n.t("connections.newConnection")}
                          </Button>
                          <Menu {...bindMenu(popupState)} {...MENU_RIGHT} classes={{ paper: classes.wideMenu }}>
                            {/* WHATSAPP */}
                            <MenuItem
                              className={classes.menuItem}
                              disabled={planConfig?.plan?.useWhatsapp ? false : true}
                              onClick={() => {
                                handleOpenWhatsAppModal();
                                popupState.close();
                              }}
                            >
                              <WhatsApp style={{ color: CHANNEL_COLOR.whatsapp }} />
                              WhatsApp
                            </MenuItem>
                            {/* WEBCHAT */}
                            <MenuItem
                              className={classes.menuItem}
                              disabled={planConfig?.plan?.useWhatsapp ? false : true}
                              onClick={() => {
                                handleOpenWhatsAppModal("webchat");
                                popupState.close();
                              }}
                            >
                              {channelIcon("webchat")}
                              {i18n.t("connections.webchat.menu")}
                            </MenuItem>
                            {/* WHATSAPP OFICIAL — automático (Embedded Signup) e manual */}
                            {metaSignup.enabled && (
                              <MenuItem
                                className={classes.menuItem}
                                onClick={() => {
                                  openMetaSignup();
                                  popupState.close();
                                }}
                              >
                                <WhatsApp style={{ color: CHANNEL_COLOR.whatsapp }} />
                                {i18n.t("connections.metaSignup.menu")}
                              </MenuItem>
                            )}
                            {metaSignup.enabled && (
                              <MenuItem
                                className={classes.menuItem}
                                onClick={() => {
                                  openMetaSignup(true);
                                  popupState.close();
                                }}
                              >
                                <WhatsApp style={{ color: CHANNEL_COLOR.whatsapp }} />
                                {i18n.t("connections.metaSignup.coexMenu")}
                              </MenuItem>
                            )}
                            <MenuItem
                              className={classes.menuItem}
                              disabled={planConfig?.plan?.useWhatsappOfficial ? false : true}
                              onClick={() => {
                                handleOpenWhatsAppModal("whatsapp_oficial");
                                popupState.close();
                              }}
                            >
                              <WhatsApp style={{ color: CHANNEL_COLOR.whatsapp }} />
                              {metaSignup.enabled ? i18n.t("connections.metaSignup.manual") : "WhatsApp Oficial"}
                            </MenuItem>
                            {/* FACEBOOK */}
                            <FacebookLogin
                              appId={process.env.REACT_APP_FACEBOOK_APP_ID}
                              autoLoad={false}
                              fields="name,email,picture"
                              version="9.0"
                              scope={process.env.REACT_APP_REQUIRE_BUSINESS_MANAGEMENT?.toUpperCase() === "TRUE" ?
                                "public_profile,pages_messaging,pages_show_list,pages_manage_metadata,pages_read_engagement,business_management"
                                : "public_profile,pages_messaging,pages_show_list,pages_manage_metadata,pages_read_engagement"}
                              callback={responseFacebook}
                              render={(renderProps) => (
                                <MenuItem
                                  className={classes.menuItem}
                                  disabled={!FB_APP_CONFIGURED || !planConfig?.plan?.useFacebook}
                                  onClick={renderProps.onClick}
                                >
                                  <Facebook style={{ color: CHANNEL_COLOR.facebook }} />
                                  Facebook
                                  {!FB_APP_CONFIGURED && (
                                    <span className={classes.menuHint}>
                                      (requer App Meta)
                                    </span>
                                  )}
                                </MenuItem>
                              )}
                            />
                            {/* INSTAGRAM */}
                            <FacebookLogin
                              appId={process.env.REACT_APP_FACEBOOK_APP_ID}
                              autoLoad={false}
                              fields="name,email,picture"
                              version="9.0"
                              scope={process.env.REACT_APP_REQUIRE_BUSINESS_MANAGEMENT?.toUpperCase() === "TRUE" ?
                                "public_profile,instagram_basic,instagram_manage_messages,pages_messaging,pages_show_list,pages_manage_metadata,pages_read_engagement,business_management"
                                : "public_profile,instagram_basic,instagram_manage_messages,pages_messaging,pages_show_list,pages_manage_metadata,pages_read_engagement"}
                              callback={responseInstagram}
                              render={(renderProps) => (
                                <MenuItem
                                  className={classes.menuItem}
                                  disabled={!FB_APP_CONFIGURED || !planConfig?.plan?.useInstagram}
                                  onClick={renderProps.onClick}
                                >
                                  <Instagram style={{ color: CHANNEL_COLOR.instagram }} />
                                  Instagram
                                  {!FB_APP_CONFIGURED && (
                                    <span className={classes.menuHint}>
                                      (requer App Meta)
                                    </span>
                                  )}
                                </MenuItem>
                              )}
                            />
                          </Menu>
                        </>
                      )}
                    />
                  </React.Fragment>
                )}
              </PopupState>
            </>} />
          <AdminNav />
          <AdminMetrics items={[{ value: whatsApps.length, label: "Canais cadastrados" }, { value: whatsApps.filter(wa => wa.status === "CONNECTED").length, label: "Conectados" }, { value: whatsApps.filter(wa => wa.status !== "CONNECTED" && wa.channel !== "webchat").length, label: "Precisam de atenção" }]} />
          <AdminSearch value={search} onChange={setSearch} placeholder="Buscar canal ou número…">
            <TextField
              select
              variant="outlined"
              size="small"
              className={classes.filterSelect}
              value={connectionFilter}
              onChange={event => setConnectionFilter(event.target.value)}
              SelectProps={{ inputProps: { "aria-label": "Filtrar canais por status" } }}
            >
              <MuiMenuItem value="all">Todos os canais</MuiMenuItem>
              <MuiMenuItem value="connected">Conectados</MuiMenuItem>
              <MuiMenuItem value="attention">Precisam de atenção</MuiMenuItem>
            </TextField>
            <div className={classes.viewToggle} role="group" aria-label="Modo de exibição">
              <Tooltip title="Cartões">
                <IconButton aria-label="Exibir cartões" aria-pressed={view === "cards"} className={clsx(view === "cards" && classes.viewActive)} onClick={() => setView("cards")}><ViewModule /></IconButton>
              </Tooltip>
              <Tooltip title="Lista">
                <IconButton aria-label="Exibir lista" aria-pressed={view === "list"} className={clsx(view === "list" && classes.viewActive)} onClick={() => setView("list")}><ViewList /></IconButton>
              </Tooltip>
            </div>
          </AdminSearch>

          {
            statusImport?.all ? (
              <div className={classes.importCard} role="status">
                <div style={{ minWidth: 0 }}>
                  <p className={classes.importTitle}>
                    {statusImport?.this === -1 ? i18n.t("connections.buttons.preparing") : i18n.t("connections.buttons.importing")}
                  </p>
                  {statusImport?.this !== -1 && (
                    <p className={classes.importText}>
                      {`${i18n.t(`connections.typography.processed`)} ${statusImport?.this} ${i18n.t(`connections.typography.in`)} ${statusImport?.all}  ${i18n.t(`connections.typography.date`)}: ${statusImport?.date} `}
                    </p>
                  )}
                </div>
                {statusImport?.this === -1 ?
                  <CircularProgress size={24} />
                  :
                  <CircularProgressWithLabel
                    value={(statusImport?.this / statusImport?.all) * 100}
                  />
                }
              </div>
            ) : null
          }

          {view === "cards" ? (
            loading ? (
              <div className={classes.cards} aria-busy="true" aria-label="Carregando canais…">
                {[0, 1, 2].map(i => (
                  <div className={classes.card} key={i}>
                    <div className={classes.cardHead}>
                      <Skeleton variant="rect" width={40} height={40} style={{ borderRadius: 8 }} />
                      <div className={classes.cardTitle}><Skeleton width="60%" height={22} /><Skeleton width="35%" height={16} /></div>
                    </div>
                    <div className={classes.cardMeta}><Skeleton width={96} height={24} /><Skeleton width="50%" height={18} /><Skeleton width="42%" height={14} /></div>
                  </div>
                ))}
              </div>
            ) : visibleConnections.length ? (
              <div className={classes.cards}>{visibleConnections.map(renderCard)}</div>
            ) : (
              <TableCard>{renderEmpty()}</TableCard>
            )
          ) : (
          <TableCard>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Canal</TableCell>
                  <TableCell>{i18n.t("connections.table.number")}</TableCell>
                  <TableCell>{i18n.t("connections.table.status")}</TableCell>
                  <TableCell>{i18n.t("connections.table.session")}</TableCell>
                  <TableCell>{i18n.t("connections.table.lastUpdate")}</TableCell>
                  <Can
                    role={user.profile === "user" && user.allowConnections === "enabled" ? "admin" : user.profile}
                    perform="connections-page:addConnection"
                    yes={() => (
                      <TableCell align="right">{i18n.t("connections.table.actions")}</TableCell>
                    )}
                  />
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRowSkeleton columns={5} />
                ) : (
                  <>
                    {whatsApps?.length > 0 &&
                      visibleConnections.map((whatsApp) => (
                        <TableRow key={whatsApp.id}>
                          <TableCell>
                            <div className={classes.nameCell}>
                              <ChannelTile channel={whatsApp.channel} color={whatsApp.color} small />
                              <div className={classes.nameText}>
                                <div className={classes.nameLine}>
                                  {whatsApp.name}
                                  {whatsApp.isDefault && (
                                    <StatusBadge color="brand" dot={false} size="sm" label={i18n.t("connections.table.default")} />
                                  )}
                                </div>
                                <div className={classes.nameSub}>{channelLabel(whatsApp.channel)}</div>
                              </div>
                            </div>
                          </TableCell>
                          <TableCell className={classes.nowrap}>
                            {connectionNumber(whatsApp) || "-"}
                          </TableCell>
                          <TableCell>
                            <div className={classes.metaLine}>
                              <ConnectionStatus status={whatsApp.status} />
                              <Can role={user.profile} perform="connections-page:addConnection" yes={() => renderMetaSignupBadge(whatsApp)} />
                            </div>
                          </TableCell>
                          <TableCell>
                            <div className={classes.sessionActions} style={{ flexWrap: "nowrap" }}>{renderActionButtons(whatsApp)}</div>
                          </TableCell>
                          <TableCell className={clsx(classes.nowrap, p.cellMuted)}>{renderUpdatedAt(whatsApp)}</TableCell>
                          <Can
                            role={user.profile}
                            perform="connections-page:addConnection"
                            yes={() => (
                              <TableCell align="right">
                                <RowActions>
                                  <Tooltip title="Configurar">
                                    <IconButton
                                      size="small"
                                      aria-label={`Configurar ${whatsApp.name}`}
                                      onClick={() => handleEditWhatsApp(whatsApp)}
                                    >
                                      <Edit />
                                    </IconButton>
                                  </Tooltip>
                                  {renderMoreMenu(whatsApp)}
                                </RowActions>
                              </TableCell>
                            )}
                          />
                        </TableRow>
                      ))}
                    {!visibleConnections.length && (
                      <TableRow>
                        <TableCell colSpan={6}>{renderEmpty()}</TableCell>
                      </TableRow>
                    )}
                  </>
                )}
              </TableBody>
            </Table>
          </TableCard>
          )}
        </>
      }
    </MainContainer >

  );
};

export default Connections;
